var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdticn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06535 8.15706L6.05469 8.44469L6.34177 6.43348L11.5125 1.26273C11.9885 0.786773 12.7601 0.786773 13.2361 1.26273C13.7121 1.73868 13.7121 2.51036 13.2361 2.98631L8.06535 8.15706Z",
    stroke: "black",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9395 1.8374L12.663 3.56099",
    stroke: "black",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 8.21887V12.2814C11.1562 12.7301 10.7925 13.0939 10.3438 13.0939H2.21875C1.77002 13.0939 1.40625 12.7301 1.40625 12.2814V4.15637C1.40625 3.70764 1.77002 3.34387 2.21875 3.34387H6.28125",
    stroke: "black",
    strokeWidth: 0.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdticn);
export default __webpack_public_path__ + "static/media/edticn.2f749b07b2ce88440a03f958f02d157a.svg";
export { ForwardRef as ReactComponent };